import React from "react";

import AvailableTimeSlots from "../../Patient/Schedule/AvailableTimeSlots";
import DatePicker from "../../UI/DatePicker";
import { daySelectHandler } from "../../../containers/Dashboard/Patient/SchedulePage";

const ScheduleWidgets = (props) => {
  return (
    <div className="Schedule__widgets col-12 col-lg-10 p-lg-4 pb-lg-5" data-public>
      <div className="row no-gutters mx-lg-3">
        <div className="col-12 col-lg-5">
          <h4 className="d-none d-lg-block fs-18 mt-2 mb-4">
            <b>Select a date</b>
          </h4>

          <DatePicker
            externalCtx={props.selectedDate}
            loadingSlots={props.timeSlotsLoading}
            mobileCardView
            noOfSlots={props.timeSlots && props.timeSlots.length}
            onDaySelect={(date) => daySelectHandler(date, props.that)}
          />
        </div>

        <div className="col-12 col-lg-7 px-3 px-lg-0">
          <AvailableTimeSlots
            click={props.onTimeSlotClick}
            conf={props.timeSlotConf}
            dateStr={props.dateStr}
            eventType={props.eventType}
            onConfirmSlotSubmit={props.onConfirmSlotSubmit}
            onEventTypeChange={props.onEventTypeChange}
            timeSlots={props.timeSlots}
            timeSlotsLoading={props.timeSlotsLoading}
            timezone={props.timezone}
          />
        </div>
      </div>
    </div>
  );
};

export default ScheduleWidgets;
